export var initialCountdown = 30;
export var accountLockedErrorMessage = 'Your account has been temporarily locked. Please try again in 10 minutes.';
export var invalidCodeErrorMessage = 'This code has either expired, been used, or is invalid. Please request a new code.';
export var codeExpiredErrorMessage = 'This code has expired. Please log in again and request a new code.';
